import {Component, Injector} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import { NavService } from 'shared/nav/nav.service';
import {ButtonList, Question} from '../../model/model';
import {QuestionPage} from '../question-page/question-page';

@Component({
  selector: 'button-list-page',
  templateUrl: 'button-list-page.html',
  styleUrls: ['button-list-page.scss'],
  host: { '[class]': '"ion-page can-go-back"' },
})
export class ButtonListPage extends QuestionPage {

  public buttons: Array<string>;
  public newButtons: Array<boolean>;

  constructor(
    private translateService: TranslateService,
    private injector: Injector,
    public navService: NavService,
  ) {
    super(injector, navService);

    const buttonList: ButtonList = <ButtonList> this.question.type;
    const lang: string = this.translateService.currentLang;
    this.buttons = buttonList.buttons.map((translatedLabel) => {return translatedLabel[lang]; });
    this.newButtons = injector.get('newButtons', []);
  }

  public onSelected(index: number): void {
    this.answerSelected.emit(index);
  }
}
